import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsKitesurfNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#sports_kitesurf_normal_large_svg__clip0_138_58)">
        <path
          d="M35.97 44.76l-.01-.01-1.82.98h-.01l-.31.17h-.01l-.67.36.94 1.76 9.55-5.08-.94-1.76-6.72 3.58zM33.46 0a24.657 24.657 0 00-10.71 2.84L12.46 8.31a24.635 24.635 0 00-8.32 7.23 8.3 8.3 0 002.08 11.74l25.71 17.35 2.62-1.4L14.1 21.19a6.249 6.249 0 01-.84-7.43c.46-.768.967-1.506 1.52-2.21l-.19.1a19.023 19.023 0 00-3.75 2.6 8.209 8.209 0 00-.12 4.88l-5.88 3.12a6.496 6.496 0 01-.19-.76 6.27 6.27 0 011.1-4.77 23.472 23.472 0 014.83-4.85c.233-.176.463-.345.7-.51a22.67 22.67 0 012.19-1.38l1.68-.89c.41-.22.82-.42 1.24-.61.773-.35 1.568-.65 2.38-.9a19.09 19.09 0 012.99-.7 22.318 22.318 0 015.1-.3 6.269 6.269 0 015.68 4.85l6.85 29.23 2.62-1.4V8.29A8.317 8.317 0 0033.46 0zM11.5 20.97a7.76 7.76 0 001.13 1.58L29.1 40.3 7.34 25.62a6.02 6.02 0 01-1.61-1.57l5.77-3.08zM26.97 4.59a24.8 24.8 0 00-3.34.04l.06-.03A22.59 22.59 0 0133.52 2a6.272 6.272 0 014.56 1.78c.178.165.342.345.489.538L32.69 7.441a8.233 8.233 0 00-5.72-2.851zm13.04 3.7v26.25l-5.52-23.57a7.914 7.914 0 00-.682-1.853l5.773-3.073c.283.715.428 1.477.429 2.246z"
          fill=""
        />
      </g>
      <defs>
        <clipPath id="sports_kitesurf_normal_large_svg__clip0_138_58">
          <path fill="#fff" d="M0 0h48v48H0z" />
        </clipPath>
      </defs>
    </svg>
  )
);
SvgSportsKitesurfNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsKitesurfNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsKitesurfNormalLarge;
